// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43')
];

export const server_loads = [];

export const dictionary = {
		"/": [12],
		"/(public)/account/email/verify": [37],
		"/(authenticated)/attendance/absence/new": [13,[2]],
		"/(authenticated)/daily-report": [14,[2,3]],
		"/(authenticated)/drop-off-notes/new": [15,[2]],
		"/(authenticated)/gallery": [16,[2,4]],
		"/(authenticated)/gallery/attachment-test": [17,[2,4]],
		"/(authenticated)/home": [18,[2,5]],
		"/(authenticated)/learning": [19,[2,6]],
		"/(authenticated)/library": [20,[2,7]],
		"/(unauthenticated)/login": [43,[11]],
		"/(public)/login/help": [38],
		"/(public)/login/reset": [39],
		"/(public)/login/reset/password": [40],
		"/(public)/login/support": [41],
		"/(authenticated)/messages": [21,[2,8]],
		"/(authenticated)/messages/new": [22,[2,8]],
		"/(authenticated)/my-account": [23,[2,9]],
		"/(authenticated)/my-account/billing": [24,[2,9]],
		"/(authenticated)/my-account/delete-account": [25,[2,9]],
		"/(authenticated)/my-account/language": [26,[2,9]],
		"/(authenticated)/my-account/my-children": [27,[2,9,10]],
		"/(authenticated)/my-account/my-children/[childKey]": [28,[2,9,10]],
		"/(authenticated)/my-account/my-children/[childKey]/attendance": [30,[2,9,10]],
		"/(authenticated)/my-account/my-children/[childKey]/contacts": [31,[2,9,10]],
		"/(authenticated)/my-account/my-children/[childKey]/[tab]": [29,[2,9,10]],
		"/(authenticated)/my-account/password": [32,[2,9]],
		"/(authenticated)/my-account/profile": [33,[2,9]],
		"/(authenticated)/my-account/profile/edit": [34,[2,9]],
		"/(authenticated)/my-account/settings": [35,[2,9]],
		"/(authenticated)/my-account/support": [36,[2,9]],
		"/(public)/support": [42]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);